import Avatar from 'components/Profile/components/Avatar/ver2';
import ProfileBodyMobile from 'components/Profile/components/ProfileBody/mobile/ver2';
import Referral from 'components/Profile/components/Referral';
import RefereeTracking from 'components/Profile/components/Referral/components/ReferralContent/RefereeTracking';
import CollapsibleSideMenu from 'components/common/CollapsibleSideMenu';
import OuterBodyContent from 'components/common/CollapsibleSideMenu/OuterBodyContent';
import OuterPathContent from 'components/common/CollapsibleSideMenu/OuterPathContent';
import NavbarFooter from 'components/common/NavbarFooter/ver3';
import { useDetectDevice } from 'hooks/useDetectDevice';
import React from 'react';

const ReferralPage = () => {
  const { isMobile, isTablet, isDesktop } = useDetectDevice();

  const getOuterPathContentStyle = () => {
    if (isDesktop)
      return {
        display: 'grid',
        gap: '24px',
        gridTemplateColumns: '667px calc(100% - 667px - 24px)',
      };
    return {};
  };

  if (isMobile || isTablet) {
    return (
      <OuterBodyContent>
        <Avatar />
        <ProfileBodyMobile />
        <NavbarFooter />
      </OuterBodyContent>
    );
  }
  return (
    <CollapsibleSideMenu>
      <OuterBodyContent>
        <OuterPathContent style={getOuterPathContentStyle()}>
          <Referral />
          <RefereeTracking />
        </OuterPathContent>
      </OuterBodyContent>
    </CollapsibleSideMenu>
  );
};

export default ReferralPage;
